import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProduct, HasProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityDto,
    AvailabilityMessageType,
    ProductSettingsModel,
    WarehouseDto,
} from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Check from "@insite/mobius/Icons/Check";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import CustomEnvelopeIcon from "@tCentro/Icons/CustomEnvelopeIcon";
import CustomInfoIcon from "@tCentro/Icons/CustomInfoIcon";
import CustomLightningBoltIcon from "@tCentro/Icons/CustomLightningBoltIcon";
import CustomTruckIcon from "@tCentro/Icons/CustomTruckIcon";
import WikaLogo from "@tCentro/Icons/WikaLogo";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    productId: string;
    availability?: AvailabilityDto;
    unitOfMeasure: string;
    trackInventory: boolean;
    isProductDetailsPage?: boolean;
    failedToLoadInventory?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    getFasterModalIsOpen?: boolean;
    setGetFasterModalIsOpen: (value: boolean) => void;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps & HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    showInventory: state.context.showInventory,
    isCartPage: getCurrentPage(state).type === "CartPage",
    cart: getCurrentCartState(state).value,
});

const mapDispatchToProps = {
    getRealTimeWarehouseInventory,
};

type Props = HasProduct & OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvailabilityStyles {
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    availabilityByWarehouseLinkGridItem?: GridItemProps;
    inventoryMessage?: InjectableCss;
    messageText?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
    availabilityByWarehouseLink?: LinkPresentationProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    availabilityByWarehouseTable?: DataTableProps;
    availabilityByWarehouseTableHead?: DataTableHeadProps;
    availabilityByWarehouseTableHeader?: DataTableHeaderProps;
    availabilityByWarehouseTableBody?: DataTableBodyProps;
    availabilityByWarehouseTableRow?: DataTableRowProps;
    availabilityByWarehouseTableCell?: DataTableCellBaseProps;
    infoIconStyles?: IconPresentationProps;
    infoLinkStyles?: InjectableCss;
    outOfStockContainerStyles?: InjectableCss;
    requireDrawingApproval?: InjectableCss;
    requireDrawingApprovalWrapper?: InjectableCss;
    drawwingApprovalIcon?: IconPresentationProps;
    iconStyles?: IconPresentationProps;
    zoneStyles?: InjectableCss;
    getFasterLinkStyles?: InjectableCss;
    getFasterLinkWithinStyles?: InjectableCss;
    inventroyMsgTextStyles?: InjectableCss;
    availabilityIconStyles?: IconPresentationProps;
    quickShipWrapper?: InjectableCss;
    quickShipContentWrapper?: InjectableCss;
    wikaheading?: TypographyPresentationProps;
    wikaSubheading?: TypographyPresentationProps;
    quickShipLogoWrap?: InjectableCss;
}

export const productAvailabilityStyles: ProductAvailabilityStyles = {
    zoneStyles: {
        css: css``,
    },
    getFasterLinkWithinStyles: {
        css: css`
            font-family: Poppins;
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            text-align: left;
            display: flex;
            span {
                display: flex;
            }
        `,
    },
    getFasterLinkStyles: {
        css: css`
            margin-left: 0px;
            font-family: Poppins;
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            text-align: left;
            display: flex;
            span {
                display: flex;
            }
        `,
    },
    iconStyles: {
        color: "#0F96D9",
        size: 16,
        css: css`
            margin-right: 0px !important;

            > svg {
                width: 9px;
                height: 12px;
            }
        `,
    },
    availabilityIconStyles: {
        css: css`
            position: relative;
            // top: 10px;
            // left: -5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        // top: 10px;
                    `,
                    css`
                    //    top: 20px;
                    `,
                    null,
                ])}
        `
    },
    outOfStockContainerStyles: {
        css: css`
            display: flex;
            align-items: center;
            margin-top: 2px;
        `,
    },
    container: {
        gap: 10,
        css: css`
            flex-grow: 0;
            height: 100%;
            > div{
                height: 100%;
            }
        `,
    },
    messageGridItem: {
        css: css`
            width: 100%;
            span[data-test-selector^="availabilityMessage"] {
                font-size: 12px;
                font-style: normal;
                color: ${getColor("text.main")};
                font-weight: 600;
                line-height: 16px;
            }
        `,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    infoIconStyles: {
        size: 12,
    },
    infoLinkStyles: {
        css: css`
            font-size: ${TYPOGRAPHY.size.tiny};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            margin-left: 4px;
            color: ${COLORS.link.base};
        `,
    },
    availabilityByWarehouseModal: {
        size: 400,
        cssOverrides: {
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                padding: 10px 10px 10px 20px;
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
        `,
    },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    errorText: {
        weight: "bold",
    },
    requireDrawingApprovalWrapper: {
        css: css`
            flex: 1 1 auto;
            max-width: 290px !important;
            width: 100% !important;
            display: flex;
            flex-direction: row;
            color: #3ca865;
            padding-top: 8px;
        `,
    },
    drawwingApprovalIcon: {
        size: 12,
        css: css`
            > svg {
                > path {
                    fill: #3ca865;
                }
            }
        `,
    },
    requireDrawingApproval: {
        css: css`
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #3ca865;
            margin-left: 2px;
        `,
    },
    inventroyMsgTextStyles: {
        css: css`
            grid-column: 2 / 3;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    null,
                ])}
        `
    },
    quickShipWrapper: {
        css: css`
            display: grid;
            align-items: center;
            padding: 5px;
            border-radius: 5px;
            grid-template-columns: 8% 89%;
            background-color: #D8F0E2;
            width: 100%;
            gap: 10px;
            padding: 14px;
            height: 100%;
            > span{
                width: auto;
                height: 100%; 
                > svg {
                    width: 100%;
                    height: 100%; 
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        > span{
                            width: 24px;  
                        }
                    `,
                    null,
                    null,
            ])}
        `
    },
    quickShipContentWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 5px;
        `
    },
    wikaheading: {
        css: css`
            font-family: Poppins;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
        `
    },
    wikaSubheading: {
        css: css`
            font-family: Poppins;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
        `
    },
    quickShipLogoWrap: {
        css: css`
            display: flex;
            align-items: center;
            gap: 5px;
            > span{
                width: 44px;
                height: 100%; 
                > svg {
                    width: 100%;
                    height: 100%; 
                }
            }
        `
    }
};

const InventoryMessage = styled.div<{ color: string }>`
    // display: flex;
    // flex-direction: column;
    align-items: center;
    padding: 5px;
    border-radius: 5px;
    display: grid;
    grid-template-columns: 8% 92%;
    &.outOfStock {
        background-color: #328ebe33;
        div {
            & > span:nth-child(1) {
                color: #328ebe;
            }
        }
    }
    background-color: ${props => safeColor(resolveColor(props.color, props.theme)).rgb().alpha(0.2).string()};
    ${IconWrapper} {
        margin-right: 10px;
    }
`;

const getAvailabilityColor = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return "common";
    }

    const availabilityType = availability?.messageType;

    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return "success";
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return "warning";
    }

    return "success";
};

const getAvailabilityIcon = (productSettings: ProductSettingsModel, availability?: AvailabilityDto) => {
    if (!productSettings.showInventoryAvailability) {
        return undefined;
    }

    const availabilityType = availability?.messageType;
    if (availabilityType === AvailabilityMessageType.OutOfStock) {
        return Check;
    }

    if (availabilityType === AvailabilityMessageType.LowStock) {
        return AlertTriangle;
    }

    return Check;
};

const showLink = (
    availability: AvailabilityDto | undefined,
    trackInventory: boolean,
    productSettings: ProductSettingsModel,
    isProductDetailsPage?: boolean,
): boolean => {
    if (
        !availability ||
        availability.messageType === AvailabilityMessageType.NoMessage ||
        !trackInventory ||
        !productSettings.showInventoryAvailability ||
        !productSettings.displayInventoryPerWarehouse
    ) {
        return false;
    }

    if (!productSettings.displayInventoryPerWarehouseOnlyOnProductDetail) {
        return true;
    }

    return !!isProductDetailsPage;
};

const CENCustomProductAvailability = ({
    productId,
    availability,
    unitOfMeasure,
    trackInventory,
    productSettings,
    isProductDetailsPage,
    getRealTimeWarehouseInventory,
    failedToLoadInventory,
    extendedStyles,
    showInventory,
    product,
    isCartPage,
    cart,
    setGetFasterModalIsOpen,
    getFasterModalIsOpen,
}: Props) => {
    const productsVariantData = useSelector((state: ApplicationState) => state.data?.products?.byId || null);
    const url: any = IS_SERVER_SIDE ? getUrl() : window.location;
    const params = new URL(url.href).searchParams;
    const option = params.get("option");
    const currentProductsVariant = option && Object.values(productsVariantData).find(item => item.productNumber === option) as any;

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [warehouses, setWarehouses] = useState<WarehouseDto[] | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const modalgetFasterModalCloseHandler = () => {
        setGetFasterModalIsOpen(false);
    };

    const openGetFasterModalHandler = () => {
        setGetFasterModalIsOpen(true);
    };

    const [isRequiredDrawingApproval, setIsRequiredDrawingApproval] = useState(false);
    useEffect(() => {
        if (product?.properties?.requiredDrawingApproval === "true") {
            setIsRequiredDrawingApproval(true);
        }
    }, []);
    const viewAvailabilityByWarehouseClickHandler = () => {
        setIsLoading(true);
        setModalIsOpen(true);
        getRealTimeWarehouseInventory({
            productId,
            unitOfMeasure,
            expand: ["warehouses"],
            onComplete: result => {
                setWarehouses(result.warehouses);
                setErrorMessage(result.errorMessage);
                setIsLoading(false);
            },
        });
    };

    const color = getAvailabilityColor(productSettings, availability);

    const className = availability?.messageType === 2 ? "outOfStock" : "";

    const iconSrc = getAvailabilityIcon(productSettings, availability);

    const [styles] = useState(() => mergeToNew(productAvailabilityStyles, extendedStyles));

    if (!showInventory) {
        return null;
    }
    if (failedToLoadInventory) {
        return (
            <StyledWrapper {...styles.errorWrapper}>
                <Typography {...styles.errorText}>{siteMessage("RealTimeInventory_InventoryLoadFailed")}</Typography>
            </StyledWrapper>
        );
    }

    const isCustomAvailabilityMsg = product?.properties?.isCustomAvailabilityMsg;
    const isQuickShip = (product?.properties?.quickShip?.toLowerCase() === "yes" || currentProductsVariant?.properties?.quickShip?.toLowerCase() === "yes") && (product?.brand?.name?.toLowerCase() === "wika" || currentProductsVariant?.brand?.name?.toLowerCase() === "wika");
    let inventoryTextComponent = <Typography {...styles.realTimeText} />;
    if (availability?.messageType !== AvailabilityMessageType.NoMessage && availability?.message?.length) {
        inventoryTextComponent = (
            <InventoryMessage className={className} color={color} {...styles.inventoryMessage}>
                <StyledWrapper
                    css={css`
                        display: flex;
                        align-items: center;
                        width: 100%;
                        grid-column: 1 / 3;
                    `}
                >
                    <Icon color={color} src={iconSrc} {...styles.availabilityIconStyles} />
                    <StyledWrapper>
                        <Typography {...styles.messageText} data-test-selector="availabilityMessage">
                            {availability.message}
                        </Typography>

                        {isProductDetailsPage && availability.messageType === 2 && isCustomAvailabilityMsg === "true" && (
                            <StyledWrapper onClick={openGetFasterModalHandler} onKeyDown={openGetFasterModalHandler} {...styles.inventroyMsgTextStyles}>
                                {/* Will display when custom availability msg is  present */}
                                <Link href="" {...styles.getFasterLinkWithinStyles}>
                                    <Icon src={CustomLightningBoltIcon} {...styles.iconStyles} />
                                    {siteMessage("Pdp_outOfStockTypicallyShipsWithin")}
                                </Link>
                            </StyledWrapper>
                        )}
                        {isProductDetailsPage && availability.messageType === 2 && isCustomAvailabilityMsg === "false" && (
                            <StyledWrapper onClick={openGetFasterModalHandler} onKeyDown={openGetFasterModalHandler} {...styles.inventroyMsgTextStyles}>
                                {/* Will display when custom availability msg is not present */}
                                <Link href="" {...styles.getFasterLinkStyles}>
                                    <Icon src={CustomLightningBoltIcon} {...styles.iconStyles} />
                                    {siteMessage("Pdp_outOfStockAvailableforPurchase")}
                                </Link>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            </InventoryMessage>
        );
    } else if (availability) {
        inventoryTextComponent = <></>;
    }

    return (
        <GridContainer {...styles.container}>
            {isQuickShip ?
                <StyledWrapper {...styles.quickShipWrapper}>
                    <Icon src={CustomTruckIcon} />
                    <StyledWrapper {...styles.quickShipContentWrapper}>
                        <StyledWrapper {...styles.quickShipLogoWrap} data-test-selector="wikaQuickShip">
                            <Icon src={WikaLogo} />
                            <Typography as="p" {...styles.wikaheading}>
                                {translate("Quick Ship")}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper>
                            <Typography as="p" {...styles.wikaSubheading}>
                                {translate("Ships in 24 hours - order by 2pm EDT")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper> :
                <>
                    <StyledWrapper {...styles.messageGridItem}>{inventoryTextComponent}</StyledWrapper>
                    {availability?.messageType === 2 && (
                        <StyledWrapper {...styles.outOfStockContainerStyles}>
                            <Icon src={CustomInfoIcon} {...styles.infoIconStyles}></Icon>
                            <Typography as="p" {...styles.infoLinkStyles} data-test-selector="subjectToFactoryLeadTimes">
                                {translate("Subject to factory lead times")}
                            </Typography>
                        </StyledWrapper>
                    )}
                </>}
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProduct(CENCustomProductAvailability));
